import React, { useContext } from 'react';

import ShowOnMouseOverUnlessTour from 'components/ShowOnMouseOverUnlessTour';
import Tooltip from 'components/Tooltip';
import CanvasContext from 'contexts/CanvasContext';
import Button from 'kingpin/atoms/Button';

import { useGadgetFullscreen } from './GadgetFullscreenProvider';

// Hover button in a gadget's header which opens the gadget over the whole
// window. Hidden where there's nothing to open (no provider), in the
// fullscreen copy itself and while the canvas is being edited.
const GadgetFullscreenButton = () => {
  const { open, isFullscreen } = useGadgetFullscreen();
  const { isEditing } = useContext(CanvasContext);

  if (!open || isFullscreen || isEditing) {
    return null;
  }

  return (
    <ShowOnMouseOverUnlessTour>
      <div style={{ marginRight: 8 }}>
        <Tooltip content="Full screen">
          <Button
            type="Ghost"
            size="Small"
            icon="fullscreen"
            onClick={open}
            testId="gadget-fullscreen-button"
          />
        </Tooltip>
      </div>
    </ShowOnMouseOverUnlessTour>
  );
};

export default GadgetFullscreenButton;
